<template>
  <div class="ScenicList">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="finishedText"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <template v-if="listData.length">
          <div class="h30"></div>
          <div class="list" v-for="item in listData" v-bind:key="item.scenicId">
            <div
              class="pic"
              :style="{
                'background-image': 'url(' + picUrl + item['scenicUrl'] + ')',
              }"
            ></div>
            <div class="text">
              <div class="name-leave">
                <p class="name van-ellipsis">{{ item.scenicName }}</p>
                <img
                  class="leave"
                  :src="picUrl + 'qunaer/scenic/level01.png'"
                  alt=""
                  v-if="item.scenicType == '3A景区'"
                />
                <img
                  class="leave"
                  :src="picUrl + 'qunaer/scenic/level02.png'"
                  alt=""
                  v-if="item.scenicType == '4A景区'"
                />
                <img
                  class="leave"
                  :src="picUrl + 'qunaer/scenic/level03.png'"
                  alt=""
                  v-if="item.scenicType == '5A景区'"
                />
                <img
                  class="leave"
                  :src="picUrl + 'qunaer/scenic/level04.png'"
                  alt=""
                  v-if="item.scenicType == '主题乐园'"
                />
              </div>
							<div class="ticketPrice">
								<template v-if="item.ticketPrice">市场价:<span class="unit">￥</span><span class="num">{{item.ticketPrice}}</span></template>
								<template v-else>暂无市场价</template>
							</div>
              <div
                class="descri van-multi-ellipsis--l2"
                v-html="descriTrans(item)"
              ></div>
              <div class="address-distance">
                <p class="address van-ellipsis">
                  <span class="iconfont iconsite icon"></span>{{ item.address }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
    <template v-if="!listData.length && !loading && !error">
      <van-empty description=".暂无景区." />
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { PullRefresh, Empty, List, Toast } from "vant";

import { getPicUrl } from '@/utils/auth'
import { getScenicList } from '@/api/index'

export default {
  name: "ScenicList",
  components: {
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
    [List.name]: List,
    [Toast.name]: Toast,
  },
  data() {
    return {
      picUrl: getPicUrl(),
      listData: [],
      loading: true,
      finished: false,
      error: false,
      refreshing: false,
      finishedText: "",
      pageNum: 0,
      pageSize: 10,
      pageTotal: 0,
      latitude: "",
      longitude: "",
      province: "",
      city: "",
    };
  },
  created() {
    try {
      this.province =
        this.$route.query && this.$route.query.arriveProvince
          ? this.$route.query.arriveProvince
          : "";
      this.city =
        this.$route.query && this.$route.query.arriveCity
          ? this.$route.query.arriveCity
          : "";

      if (this.province == "" && this.city == "") {
        this.loading = false;
        console.log('参数获取为空')
        return;
      }
      this.onLoad()
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    // 景区列表
    getScenicList() {
      try {
      const that = this
      const isLine = 1
      const productType = process.env.VUE_APP_PRODUCT_TYPE
      const {pageNum, pageSize, province, city } = this
      getScenicList({ pageNum, pageSize, isLine, province, city, productType })
        .then((res) => {
          console.log('3')
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.data.code != 200) {
            throw res.data.msg;
          }
          if (res.data.code == 200) {
            const total = res.data.data.total;
            let listData = [];
            if (that.pageNum < 2) {
              listData = res.data.data.list || [];
            }

            if (that.pageNum > 1) {
              listData = that.listData.concat(res.data.data.list);
            }

            this.listData = listData;
            // 加载状态结束
            that.loading = false;

            // 数据全部加载完成
            if (listData.length >= total) {
              that.finished = true;
              that.finishedText = listData.length ? "已经到底了" : "";
            }
          }
        })
        .catch(() => {
          console.log('4')
          that.loading = false;
          that.error = true;
          that.pageNum = that.pageNum - 1;
        });
      } catch (error) {
        console.log(error)
      }
    },
    onLoad() {
      try {
        this.finishedText = this.pageNum < 1 ? "" : "已经到底了";
        this.pageNum = this.pageNum + 1;
        console.log('2')
        this.getScenicList();
      } catch (error) {
        console.log(error)
      }
    },
    // 下拉刷新
    onRefresh() {
      this.pageNum = 0;
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    descriTrans(item) {
      return item.introduction.replace(/href/g, "");
    },
  },
};
</script>

<style scoped>
html,
body {
  width: 100% !important;
  height: 100% !important;
}
.h30 {
  height: 30px;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto 30px auto;
  box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 1);
  border-radius: 10px;
  width: calc(100% - 30px);
  height: 220px;
  background: #fff;
  overflow: hidden;
}
.list .pic {
  flex: 0 0 255px;
  width: 255px;
  height: 255px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.list .text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 15px 20px 15px;
  width: calc(100% - 280px);
  height: 210px;
}
.list .name-leave {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 45px;
  font-size: 32px;
  font-weight: bold;
  line-height: 45px;
}
.list .name {
  width: calc(100% - 100px);
}
.list .name-leave .leave {
  width: 96px;
  height: 32px;
}
.list .ticketPrice {
  height: 40px;
  font-size: 24px;
	line-height: 40px;
  font-weight: bold;
}
.list .ticketPrice .unit,
.list .ticketPrice .num {
  color:#FF4C4C;
}

.list .descri {
  height: 80px;
  font-size: 24px;
  line-height: 40px;
  color: #666;
}
.list .descri >>> a {
  color: #666 !important;
}
.list .descri >>> img {
  display: none !important;
}
.list .address {
  width: 100%;
  height: 30px;
  font-size: 22px;
  line-height: 30px;
  color: #999;
}
.list .address .icon {
  margin-right: 5px;
  font-size: 22px;
}
</style>
